export const RequestSpaceCreateDataService = Symbol('RequestSpaceCreateDataService');
